import React, { createContext, useContext, ReactNode } from 'react';

interface DialogContextProps {
  isOpen: boolean;
  onClose: () => void;
}

const DialogContext = createContext<DialogContextProps | undefined>(undefined);

interface DialogProviderProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const DialogProvider: React.FC<DialogProviderProps> = ({ isOpen, onClose, children }) => {
  return <DialogContext.Provider value={{ isOpen, onClose }}>{children}</DialogContext.Provider>;
};

export const useDialog = (): DialogContextProps => {
  const context = useContext(DialogContext);
  if (context === undefined) {
    throw new Error('useDialog must be used within a DialogProvider');
  }
  return context;
};
